export default "__VITE_ASSET__d9946766__"